import React from "react";
import ModalBasic from "./ModalBasic";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

// 회원탈퇴 후 재가입 못하도록 안내 모달창 띄우기
const ModalRejoinBlocked = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate("/", { replace: true });
    onClose();
  };

  return (
    <ModalBasic
      isOpen={isOpen}
      onClose={handleConfirm}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      width={window.innerWidth > 430 ? "700px" : "362px"}
      height={window.innerWidth > 430 ? "258px" : "187px"}
      top="50%"
      left="50%"
    >
      <ContentBox>
        <Message>
          이미 탈퇴 처리된 계정입니다.<br />
          탈퇴한 계정으로는 다시 가입할 수 없습니다.
        </Message>
        <ButtonRow>
          <ConfirmButton onClick={handleConfirm}>확인</ConfirmButton>
        </ButtonRow>
      </ContentBox>
    </ModalBasic>
  );
};

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 32px 24px 34px;

  @media (max-width: 430px) {
    padding: 46px 24px 23px;
  }
`;

const Message = styled.div`
  color: #000;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px; 
  letter-spacing: -0.4px;
  margin-bottom: 26px;
  text-align: center;

  @media (max-width: 430px) {
    font-size: 18px;
    line-height: 28px; 
    letter-spacing: -0.32px;
    margin-bottom: 16px;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  justify-content: center;
`;

const ConfirmButton = styled.button`
  width: 120px;
  height: 50px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 24px;
  background: #000;
  color: #00f370;
  padding: 2px;

  @media (max-width: 430px) {
    width: 80px;
    height: 40px;
    font-size: 16px;
  }
`;

export default ModalRejoinBlocked;
